import React from 'react';
import PropTypes from 'prop-types';

const SocialSharePopup = ({ onClose }) => (
  <div className="social-share-popup-container">
    <div className="social-share-popup">
      <div className="header">
        <div className="title">Publicar en Redes Sociales</div> h
        <button type="button" className="close-button" aria-label="Close" onClick={onClose}>CLOSE</button>
      </div>
      <div className="content" />
    </div>
  </div>
);

SocialSharePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SocialSharePopup;
